import {AIActivity} from "@khan/guide-types";

/**
 * Determine if the given activity name (also known as "config name" or "bot
 * config") corresponds to the Tutor Me activity OR the old (legacy) name of the
 * Tutor Me activity.
 *
 * The activity name is a string that typically starts with
 * "activity-". The check allows null/undefined to be permissive of optional
 * inputs.
 *
 */
export function isTutorMeActivity(name: string | null | undefined): boolean {
    return name === AIActivity.TutorMe || name === AIActivity.TutorMeLegacy;
}
